import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import useAuth from "$hooks/useAuth";
import { useAppReset } from "$hooks/useAppReset";

const PUBLIC_ROUTES = ["/", "/connexion", "/mot-de-passe", "/succes"];

function isPublicRoute(pathname: string) {
  return (
    PUBLIC_ROUTES.includes(pathname) ||
    pathname.includes("/dossier-expedition/")
  );
}

function AuthController() {
  const location = useLocation();

  const { getNewToken, logout, setAuthState } = useAuth();
  const { resetAll } = useAppReset();

  useEffect(() => {
    const auth = localStorage.getItem("authState");
    if (auth) {
      const authState = JSON.parse(auth);
      if (authState.token)
        localStorage.setItem("access_token", authState.token);
      const refresh_token = localStorage.getItem("refresh_token");
      if (refresh_token && authState?.user) {
        getNewToken(authState);
      } else {
        setAuthState({ ...authState, isLoggedIn: true, loading: false });
      }
    } else if (!isPublicRoute(location.pathname)) {
      resetAll();
      logout();
    }
  }, [getNewToken, logout, resetAll, setAuthState, location]);

  return null;
}

export default AuthController;
